import { Pipe, PipeTransform } from '@angular/core';
import { ScanFile } from 'src/app/models/scan.model';

@Pipe({
    name: 'filterByImageType'
})
export class FilterByImageTypePipe implements PipeTransform {

    transform(value: ScanFile[]): ScanFile[] {

        return value.filter((v) =>
            ['jpg', 'jpeg', 'png'].includes(v.type.toLocaleLowerCase())
        )

    }
}
